import { UserLimits } from '../../../models/limits/limits.model';
import { useGet, useSend } from '../../useApi';

// GET /admin/users/{id}/limits, POST …/limits/overrides, DELETE …/overrides/{id}.
const useUserLimits = () => {
  const { data, loading, fetch, setData } = useGet<UserLimits>('Failed to load the customer’s limits');
  const { loading: saving, send } = useSend('Could not change the limit');
  const fetchLimits = (userId: string) => fetch(`api/v1/admin/users/${userId}/limits`);
  return {
    limits: data,
    loading,
    saving,
    clear: () => setData(null),
    fetchLimits,
    setOverride: (userId: string, body: { limit_key: string; amount: number; reason: string; expires_at?: string | null }, onDone?: () => void) =>
      send({ url: `api/v1/admin/users/${userId}/limits/overrides`, method: 'post', data: body }, () => {
        fetchLimits(userId);
        onDone?.();
      }),
    removeOverride: (userId: string, overrideId: string, reason: string) =>
      send({ url: `api/v1/admin/users/${userId}/limits/overrides/${overrideId}`, method: 'delete', data: { reason } }, () =>
        fetchLimits(userId)
      ),
  };
};

export default useUserLimits;
